<div
  id="recurring-ranking-root"
  class="recurring-ranking">
  <div class="recurring-ranking-header">
    <div class="recurring-ranking-title">
      <span [innerHTML]="'home.trophies-recurring-ranking.bag-ranking.title_1' | translate | uppercase"></span>
    </div>
    <div class="recurring-ranking-subtitle">
      {{ 'home.trophies-recurring-ranking.bag-ranking.title_2' | translate }}
    </div>
  </div>

  <div
    id="ranking-container"
    class="recurring-ranking-item-container"
    (scroll)="scroll()"
    [ngClass]="{
      'list-blur': !loading() && (disabled() || !hasTrophies())
    }">
    @if (!loading()) {
      @for (rankingUser of rankingObject().trophyRanking; track rankingUser) {
        <slotcom-ranking-item
          [rankingUser]="rankingUser"
          [isUser]="rankingUser.userId === userId"
          [hiddenInList]="rankingUser.userId === userId && showFloatingUser()">
        </slotcom-ranking-item>
      }
    }

    @if (loading()) {
      <div class="recurring-ranking-loader-container">
        <div class="recurring-ranking-loader"></div>
      </div>
    }
  </div>

  @if (currentUser() && showFloatingUser() && !loading() && hasTrophies() && !disabled()) {
    <div
      class="floating-user-item"
      [ngClass]="{
        'floating-user-item--top': stickyTop(),
        'floating-user-item--bottom': stickyBottom()
      }">
      <slotcom-ranking-item
        [rankingUser]="currentUser()"
        [isUser]="true">
      </slotcom-ranking-item>
    </div>
  }

  @if (!loading()) {
    @if (!disabled() && !hasTrophies()) {
      <div class="recurring-ranking-no-available-container">
        <div
          class="disabled-text line-height mt-1"
          [innerHTML]="'home.recurring-ranking.bag-ranking.help-new-user' | translate"></div>
        <div class="recurring-ranking-no-available-img recurring-ranking-no-available-img-blocked"></div>
      </div>
    }

    @if (disabled()) {
      <div class="recurring-ranking-no-available-container">
        <div class="recurring-ranking-no-available-img recurring-ranking-no-available-img-updating"></div>
        <div
          class="disabled-text line-height"
          [innerHTML]="'home.recurring-ranking.bag-ranking.help-no-available' | translate"></div>
      </div>
    }
  }
</div>
